import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummaryGrossIncome({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/report-gross-income"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="xl"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('gross_income')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="vertical-center" style={{ 'width': '15%' }}>
						<h6 className="d-flex justify-content-between">
							<b>{t('amount')}:</b>
							<span>{formatMoney(data?.total_income)}</span>
						</h6>
						<h6 className="d-flex justify-content-between">
							<b>{t('allowances')}:</b>
							<span>{formatMoney(data?.total_allowances)}</span>
						</h6>
					</div>

					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '50%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('price')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('sale_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">{t('gross_income')}</th>
									<th style={{ 'width': '10%' }} className="text-end td-ellipsis">%</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td className="text-end">{formatMoney(item.total_quantity)}</td>
										<td className="text-end">{formatMoney(item.price)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.total_income)}</td>
										<td className="text-end">{formatMoney(item.percent, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummaryGrossIncome